import { get } from 'lodash';

const getWeightLimit = deliveryValidation => {
  const hasWeightLimit = get(
    deliveryValidation,
    'deliverySettings.weightLimit',
    false
  );
  if (!hasWeightLimit) {
    return null;
  }
  const weightLimit = get(
    deliveryValidation,
    'deliverySettings.weightLimitAmount'
  );
  const weightLimitUnit = get(
    deliveryValidation,
    'deliverySettings.weightUnit'
  );
  return `${weightLimit}${convertWeightUnit(weightLimitUnit)}`;
};

const getDimensionLimit = deliveryValidation => {
  const hasDimensionLimit = get(
    deliveryValidation,
    'deliverySettings.dimensionLimit',
    false
  );
  if (!hasDimensionLimit) {
    return null;
  }
  const dimensionLimit = get(
    deliveryValidation,
    'deliverySettings.dimensionLimitAmount'
  );
  const dimensionLimitUnit = get(
    deliveryValidation,
    'deliverySettings.dimensionUnit'
  );
  return `${dimensionLimit}${convertDimensionUnit(dimensionLimitUnit)}`;
};

const WEIGHT_UNITS = {
  LB: 'lb',
  KG: 'kg',
  OZ: 'oz',
  G: 'g'
};

const DIMENSION_UNITS = {
  IN: '"',
  FT: "'",
  MM: 'mm',
  CM: 'cm',
  M: 'm'
};

// fall back to the unit code itself so a new admin unit never shows as "undefined"
function convertWeightUnit(unit) {
  return WEIGHT_UNITS[unit] ?? unit?.toLowerCase() ?? '';
}

function convertDimensionUnit(unit) {
  return DIMENSION_UNITS[unit] ?? unit?.toLowerCase() ?? '';
}

export { getWeightLimit, getDimensionLimit };
